import React from 'react';

function PromoProduct(props) {

  const isMobile = window.innerWidth < 768;

  const backgroundImageStyle = {
    backgroundImage: `url(${isMobile ? props.promoData.mobilePictureSrc : props.promoData.desktopPictureSrc})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat'
  };

  return (
      <div className="product-item promo-item">
        <a href={props.promoData.url} style={backgroundImageStyle}></a>
      </div>
  );
}

export default PromoProduct;
